<template>
  <component :is="withCard ? 'el-card' : 'div'" ref="card">
    <filter-box
      :labelPosition="labelPosition"
      :inline="inline"
      :labelWidth="labelWidth"
      :formConfig="formConfig"
      :form="filterObj"
      :hideOperate="hideOperate"
      ref="filterBox"
      @collapse-change="changeTableHeight"
    >
      <div slot="footer">
        <slot name="footer"></slot>
      </div>
    </filter-box>

    <slot name="expand"></slot>
    <element-table
      ref="table"
      :data="data"
      :columns="columns"
      :loading="loading"
      :height="tableHeight"
      :maxHeight="tableHeight"
      border
      stripe
      :expandAll="expandAll"
      :row-class-name="rowClassName"
      @on-selection-change="selectionChange"
      @on-sort-change="handleSortChange"
      @on-current-change="handleTableCurrentChange"
      @on-row-click="rowClick"
    ></element-table>
    <el-pagination
      ref="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="pagination.pageSizes || pagesize"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.totalCount"
      style="margin-top: 20px"
      class="table-pagination"
    >
    </el-pagination>
  </component>
</template>

<script>
import { find } from "lodash";
import { formatDate } from "@/utils/common";
import { mapGetters } from "vuex";
import FilterBox from "@/components/filter-box";
import debounce from "lodash/debounce";
import ElementTable from "@/components/ElementTable";
export default {
  props: {
    withCard: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    data: Array,
    columns: Array,
    filterObj: Object,
    formConfig: Array,
    pagination: Object,
    expandAll: {
      type: Boolean,
      default: false
    },
    expandHeight: {
      type: Number,
      default: 0
    },
    labelPosition: {
      type: String,
      default: "right"
    },
    labelWidth: {
      type: String
    },
    inline: {
      type: Boolean,
      default: false
    },
    hideOperate: {
      type: Boolean,
      default: false
    },
    rowClassName: Function
  },
  inject: {
    handleSizeChange: {
      from: "handleSizeChange",
      default: () => {
        return () => {};
      }
    },
    handleCurrentChange: {
      from: "handleCurrentChange",
      default: () => {
        return () => {};
      }
    }
  },
  components: {
    FilterBox,
    ElementTable
  },
  data() {
    return {
      tableHeight: 0,
      pagesize: [10, 20, 50],
      isResizeClass: true
    };
  },
  mounted() {
    this.changeTableHeight();
    this.__resizeHandler = debounce(() => {
      this.changeTableHeight();
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.__resizeHandler);
  },
  methods: {
    selectionChange(params) {
      this.$emit("on-selection-change", params);
    },
    handleSortChange(params) {
      this.$emit("on-sort-change", params);
    },
    handleTableCurrentChange(rows) {
      this.$emit("on-current-change", rows);
    },
    toggleRowSelection(row) {
      this.$refs.table.toggleRowSelection(row);
    },
    toggleRowExpansion(row, expanded) {
      this.$refs.table.toggleRowExpansion(row, expanded);
    },
    doLayout() {
      this.$refs.table.doLayout();
    },
    rowClick(row, column) {
      this.$emit("on-row-click", row, column);
    },
    changeTableHeight() {
      this.$nextTick(() => {
        const wHeight = window.innerHeight;
        // 内容区域 = 浏览器可视化区域高度 - Header高度 - card padding - card border
        const cardHeight = wHeight - 64 - 48 - 40 - 2;
        // 页码高度 = 分页内容高度 + margin
        const paginationHeight = this.$refs.pagination.$el.offsetHeight + 20;
        const filterBoxHeight = this.$refs.filterBox.$el.offsetHeight;
        const tableHeight =
          cardHeight - filterBoxHeight - paginationHeight - this.expandHeight;
        this.tableHeight = tableHeight < 300 ? 300 : tableHeight;
      });
    }
  }
};
</script>

<style lang="scss">
.table-pagination {
  text-align: right;
  .el-pagination__total {
    float: left;
  }
  .el-pagination__sizes {
    float: left;
  }
  .filter-form .el-form-item__label {
    font-size: 16px;
  }
}
</style>
